import { render, staticRenderFns } from "./MockupSection.vue?vue&type=template&id=c8549c8c&scoped=true&"
import script from "./MockupSection.vue?vue&type=script&lang=js&"
export * from "./MockupSection.vue?vue&type=script&lang=js&"
import style0 from "./MockupSection.vue?vue&type=style&index=0&id=c8549c8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8549c8c",
  null
  
)

export default component.exports